import actions from './actions'

export default function ProtocolAssignmentReducer(state = { loading: false }, action) {
  switch (action.type) {
    case actions.REQUESTING:
      return {
        ...state,
        loading: true,
        saveSuccess: false,
      }
    case actions.LIST_PROTOCOLASSIGNMENT:
      return {
        ...state,
        result: action.result,
        loading: false,
        saveSuccess: false,
      }
    case actions.EDIT_PROTOCOLASSIGNMENT:
      return {
        ...state,
        editing: action.result,
        loading: false,
        saveSuccess: false,
        openModal: true,
      }
    case actions.RESET_PROTOCOLASSIGNMENT:
      return {
        ...state,
        editing: null,
        loading: false,
        saveSuccess: false,
      }
    case actions.NEW_PROTOCOLASSIGNMENT:
      return {
        ...state,
        editing: { protocolAssignmentID: 0 },
        loading: false,
        saveSuccess: false,
        openModal: true,
      }
    case actions.SAVE_PROTOCOLASSIGNMENT_RECIEVED:
      console.log('SAVE_PROTOCOLASSIGNMENT_RECIEVED')
      return {
        ...state,
        editing: { protocolAssignmentID: 0 },
        loading: false,
        saveSuccess: true, // mark
        openModal: false,
      }
    case actions.DELETE_PROTOCOLASSIGNMENT_RECIEVED:
      console.log('DELETE_PROTOCOLASSIGNMENT_RECIEVED')
      return {
        ...state,
        editing: { protocolAssignmentID: 0 },
        loading: false,
        saveSuccess: true, // mark
        openModal: false,
      }
    case actions.RESPONSE_ERROR:
      return {
        ...state,
        loading: false,
        error: true,
        saveSuccess: false,
        message: action.message,
      }
    default:
      return state
  }
}
